import React from 'react';

import { isTodayOrBefore } from '../../../../../../../services/date/validators';
import DateTemplate from '../../../../../setup/shared/GenerateHtml/DateTemplate';

import './TableDate.scss';

export default function TableDate({ value, placeholder, onChange }) {
  return (
    <div className="patient-profile-medications-table-cell-date">
      <DateTemplate
        value={value}
        isValidDate={isTodayOrBefore}
        legacyLook
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  );
}
